import { render, staticRenderFns } from "./PSelect.vue?vue&type=template&id=96aa3afa&"
import script from "./PSelect.vue?vue&type=script&lang=ts&"
export * from "./PSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports